import { render, staticRenderFns } from "./KusClientFormPivotDate.vue?vue&type=template&id=4aaaedbd"
import script from "./KusClientFormPivotDate.vue?vue&type=script&lang=js"
export * from "./KusClientFormPivotDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports